export class CacheService{

    public actualizaDatos : number;
    public dataContractMedicalAppointment : number;

    constructor(){
        this.actualizaDatos = 0;
        this.dataContractMedicalAppointment = 0;
    }      

}


// WEBPACK FOOTER //
// /app/src/app/shared/models/cache-service.model.ts